import AsteriskMark from "./AsteriskMark";
import Tag from "./Tag";
import styles from "./MobileBlock.module.css";

// Shown instead of the portal on phone-sized screens
export default function MobileBlock() {
  return (
    <main className={styles.page}>
      <header className={`${styles.brand} d-flex flex-column align-items-center`}>
        <AsteriskMark className={styles.mark} />
        <h1 className={styles.title}>PropFunding</h1>
        <Tag className={styles.badge}>Admin portal</Tag>
      </header>
      <p className={styles.message}>
        Better on a computer{" "}
        <span role="img" aria-label="zany face">
          🤪
        </span>
      </p>
    </main>
  );
}
